import { Phone, MapPin, Clock, ArrowUp, FileText } from "lucide-react";
import { BUSINESS, SERVICES, NAV_LINKS } from "@/data/site";
import { scrollToId } from "@/lib/scroll";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 bg-ink2 pt-20 pb-28 lg:pb-10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid md:grid-cols-12 gap-12 md:gap-8">
        <div className="md:col-span-5">
          <div className="mb-6">
            <img src="/logo.png" alt="Big Rickie's Pressure Washing & External Cleaning" className="h-40 sm:h-48 w-auto" data-testid="footer-logo-img" />
          </div>
          <p className="text-slate-400 text-sm leading-relaxed max-w-sm mb-8">
            Locally owned and operated from Flora Hill. Residential and commercial exterior cleaning across Bendigo and Central Victoria.
          </p>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={`tel:${BUSINESS.phoneRaw}`} className="flex items-center gap-3 text-white hover:text-brand-light transition-colors font-display font-bold text-xl tracking-wide" data-testid="footer-phone-link">
                <Phone size={16} className="text-brand-light" /> {BUSINESS.phone}
              </a>
            </li>
            <li className="flex items-center gap-3 text-slate-400"><MapPin size={16} className="text-brand-light" /> {BUSINESS.location}</li>
            <li className="flex items-center gap-3 text-slate-400"><Clock size={16} className="text-brand-light" /> {BUSINESS.hours}</li>
            <li className="flex items-center gap-3 text-slate-400 font-mono text-xs tracking-wider" data-testid="footer-abn"><FileText size={16} className="text-brand-light" /> ABN {BUSINESS.abn}</li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="eyebrow mb-5">Services</div>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <button onClick={() => scrollToId("services")} className="text-sm text-slate-400 hover:text-white transition-colors text-left" data-testid={`footer-service-${s.id}`}>
                  {s.title}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow mb-5">Explore</div>
          <ul className="space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <button onClick={() => scrollToId(l.href)} className="text-sm text-slate-400 hover:text-white transition-colors" data-testid={`footer-link-${l.href}`}>
                  {l.label}
                </button>
              </li>
            ))}
            <li>
              <button onClick={() => scrollToId("quote")} className="text-sm text-brand-light hover:text-white transition-colors font-semibold" data-testid="footer-link-quote">
                Get a free quote
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
        <span>© {new Date().getFullYear()} {BUSINESS.name} · ABN {BUSINESS.abn}</span>
        <span className="flex items-center gap-6">
          <a href="/admin" className="hover:text-slate-300 transition-colors" data-testid="footer-admin-link">Admin</a>
          <button onClick={() => scrollToId("top")} className="inline-flex items-center gap-2 hover:text-white transition-colors" data-testid="footer-back-to-top">
            Back to top <ArrowUp size={12} />
          </button>
        </span>
      </div>
    </div>
  </footer>
);

export const MobileCallBar = () => (
  <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 p-3 bg-ink/90 backdrop-blur-xl border-t border-white/10 grid grid-cols-2 gap-3" data-testid="mobile-call-bar">
    <a href={`tel:${BUSINESS.phoneRaw}`} className="btn-primary !py-3 !text-base" data-testid="mobile-bar-call-btn">
      <Phone size={16} strokeWidth={2.5} /> Call now
    </a>
    <button onClick={() => scrollToId("quote")} className="btn-gold !py-3 !text-base" data-testid="mobile-bar-quote-btn">
      Free quote
    </button>
  </div>
);
